import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { getFormattedNumber } from '../../../../../../../../common/utils'
import Status from '../status'

class FiberTable extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      result,
      translate,
      classes,
      isbi,
      isloop,
      idx
    } = this.props
    const fiberData = result.map((n, k) => {
      let direction
      if (isloop) {
        if (isbi) {
          if (idx === 0) {
            if (n.handset === '1') {
              direction = `Main ${translate('fiber_loop_b_to_a')}`
            } else {
              direction = `Main ${translate('fiber_loop_a_to_b')}`
            }
          } else {
            direction = translate('fiber_loop_a_to_b')
          }
        } else {
          direction = `Main ${translate('fiber_loop_b_to_a')}`
        }
      } else {
        if (n.handset === '1') {
          direction = translate('fiber_remote_to_main')
        } else {
          direction = translate('fiber_main_to_remote')
        }
      }

      let handset
      if (isbi && isloop) {
        handset = 1
      } else if (idx !== undefined) {
        if (idx === 0 && n.handset === '1') {
          handset = 1
        } else if (idx === 0 && n.handset === '2') {
          handset = 2
        } else if (idx === 1 && n.handset === '1') {
          handset = 2
        } else if (idx === 1 && n.handset === '2') {
          handset = 1
        }
      } else {
        handset = n.handset
      }

      return {
        handset,
        direction,
        wavelength: n.wavelength,
        corediameter: n.corediameter,
        loss: n.loss,
        lossbudget: n.lossbudget,
        marginbudget: n.marginbudget,
        teststatus: n.teststatus
      }
    }).sort((a, b) => (a.handset - b.handset || a.wavelength - b.wavelength))

    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>{translate('fiber_n')}</TableCell>
            <TableCell>{translate('fiber_test_direction')}</TableCell>
            <TableCell numeric>{translate('fiber_wavelength')}</TableCell>
            <TableCell numeric>{translate('fiber_corediameter')}</TableCell>
            <TableCell numeric>{translate('fiber_insertionloss')}</TableCell>
            <TableCell numeric>{translate('fiber_lossbudget_limit')}</TableCell>
            <TableCell numeric>{translate('fiber_margin')}</TableCell>
            <TableCell>{translate('fiber_result')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            (fiberData && fiberData.length) ? (fiberData.map((fiber, k) => {
              return (<TableRow key={k}>
                {/* <TableCell component="th" scope="row">Fiber {isbi && isloop ? 1 : n.handset}</TableCell> */}
                <TableCell component="th" scope="row" style={{color: fiber.handset == 2 ? '#FBA71A' : '#24418F'}}>{translate('general_fiber')} {fiber.handset}</TableCell>
                {/* <TableCell numeric>{isloop ? translate('fiber_main_to_main') : n.handset === "1" ? translate('fiber_remote_to_main') : translate('fiber_main_to_remote')}
                </TableCell> */}
                <TableCell numeric>{fiber.direction}</TableCell>
                <TableCell numeric>{parseFloat(getFormattedNumber(fiber.wavelength))}</TableCell>
                <TableCell numeric>{parseFloat(getFormattedNumber(fiber.corediameter))}</TableCell>
                <TableCell numeric>{getFormattedNumber(fiber.loss)}</TableCell>
                <TableCell numeric>{getFormattedNumber(fiber.lossbudget)}</TableCell>
                <TableCell numeric>{getFormattedNumber(fiber.marginbudget)}</TableCell>
                <TableCell numeric>{fiber.teststatus ? (<React.Fragment> <Status status={fiber.teststatus} /></React.Fragment>) : (translate('general_na'))}</TableCell>
              </TableRow>)
            })) : null}
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(styles)(FiberTable)

